import 'angular';
import 'angular-resource';
import AngularRoute from 'angular-route';
import 'angular-gettext';

import RingTabsNg from '@jetbrains/ring-ui/components/tabs-ng/tabs-ng';
import '@jetbrains/ring-ui/components/form/form.scss';
import '@jetbrains/ring-ui/components/link/link__legacy.css';
import RingFromNg from '@jetbrains/ring-ui/components/form-ng/form-ng';
import '@jetbrains/ring-ui/components/button/button';
import '@jetbrains/ring-ui/components/panel/panel.scss';
import '@jetbrains/ring-ui/components/loader/loader';
import RingBreadcrumbNg from '@jetbrains/ring-ui/components/breadcrumb-ng/breadcrumb-ng';
import '@jetbrains/ring-ui/components/button-group/button-group';
import RingButtonNg from '@jetbrains/ring-ui/components/button-ng/button-ng';
import ButtonGroupNg from '@jetbrains/ring-ui/components/button-group-ng/button-group-ng';
import PanelNg from '@jetbrains/ring-ui/components/panel-ng/panel-ng';
import FooterNg from '@jetbrains/ring-ui/components/footer-ng/footer-ng';
import IconNg from '@jetbrains/ring-ui/components/icon-ng/icon-ng';
import LoaderInlineNg from '@jetbrains/ring-ui/components/loader-inline-ng/loader-inline-ng';
import CheckboxNg from '@jetbrains/ring-ui/components/checkbox-ng/checkbox-ng';
import AutofocusNg from '@jetbrains/ring-ui/components/autofocus-ng/autofocus-ng';
import {copyright} from '@jetbrains/ring-ui/components/footer/footer';

import './app.scss';
import '../ring-tooltip-ng/ring-tooltip-ng.scss';
import AppConfig from './app__config';
import i18nModule from '../i18n/i18n';
import '../ring-dialog/ring-dialog.scss';
//Pages:
import BaseSettings from '../../pages/base-settings/base-settings';
import HubSettings from '../../pages/hub-settings/hub-settings';
import LicensePage from '../../pages/license/license';
import UpgradeSource from '../../pages/upgrade-source/upgrade-source';
import UpgradeSettings from '../../pages/upgrade-settings/upgrade-settings';
import LicenseAgreement from '../../pages/license-agreement/license-agreement';
import Welcome from '../../pages/welcome/welcome';
import InstallationProgress from '../../pages/installation-progress/installation-progress';
import WizardLogin from '../../pages/login/login';

import Logo from '../logo/logo';
import Title from '../installation-title/installation-title';

// eslint-disable-next-line import/no-unresolved
import '!!file-loader?name=favicon.ico!@jetbrains/logos/jetbrains/favicon.ico';

import Storage from '@jetbrains/ring-ui/components/storage/storage';
import AppAuth from './app.auth';

angular.module('installer', [
  AngularRoute,
  'gettext',

  RingFromNg,
  RingTabsNg,
  RingBreadcrumbNg,
  RingButtonNg,
  FooterNg,
  IconNg,
  LoaderInlineNg,
  CheckboxNg,
  AutofocusNg,
  ButtonGroupNg,
  PanelNg,

  AppConfig.name,
  Logo.name,
  Title.name,
  i18nModule.name,
  AppAuth.name,
  WizardLogin.name,

  Welcome.name,
  BaseSettings.name,
  HubSettings.name,
  LicensePage.name,
  InstallationProgress.name,
  LicenseAgreement.name,
  UpgradeSource.name,
  UpgradeSettings.name
]).
  config(($routeProvider, $locationProvider) => {
    $locationProvider.html5Mode(true);

    $routeProvider.
      when('/', {
        redirectTo: '/welcome'
      }).
      otherwise({
        redirectTo: '/welcome'
      });
  }).
  factory('appStorage', () => new Storage()).
  directive('installerRootLink', $window => (scope, iElement) => {
    iElement[0].addEventListener('click', () => {
      $window.location.href = '';
    });
  }).
  directive('installerFooter', () => ({
    template: `
<rg-footer class="app__footer ng-cloak">
  <rg-footer-center>
    <rg-footer-line>
      <span translate>${copyright(2000)} {{:: copyrightText}}</span>
    </rg-footer-line>
  </rg-footer-center>
</rg-footer>
    `,
    controller: function controller($scope, i18n) {
      $scope.copyrightText = i18n('JetBrains · All rights reserved');
    }
  })).
  directive('installerBackgroundColor', () => ({
    link: ($scope, iElement) => {
      const WHITE = 'app_white';
      const element = iElement[0];
      $scope.$on('$routeChangeSuccess', (e, route) => {
        // eslint-disable-next-line angular/no-private-call
        if (route.$$route.originalPath === '/login') {
          element.classList.add(WHITE);
        } else {
          element.classList.remove(WHITE);
        }
      });
    }
  })).
  factory('languageSelect', gettextCatalog => function factory(lang) {
    const localization = require(`../../translations/${ lang }.pot`);
    gettextCatalog.setStrings(lang, localization);
    gettextCatalog.setCurrentLanguage(lang);
  }).
  /**
   * Returns back defaults changed in 1.6.0:
   */
  config($compileProvider => {
    $compileProvider.preAssignBindingsEnabled(true);
  }).
  config($qProvider => {
    $qProvider.errorOnUnhandledRejections(false);
  });



// WEBPACK FOOTER //
// ./src/blocks/app/app.js